import { jsx as o, jsxs as f, Fragment as h } from "react/jsx-runtime";
import s from "classnames";
import { useId as l, useReducer as p, useState as b, useEffect as _ } from "react";
import { V as A } from "./VisuallyHidden-42oizZZl.js";
import { I as v } from "./Icon-BcAne5bE.js";
const R = (n) => N(n) ? /* @__PURE__ */ o(I, { ...n }) : /* @__PURE__ */ o(y, { ...n }), I = ({
  className: n,
  children: r,
  expanded: e,
  onExpand: t
}) => {
  const c = l(), a = l();
  return /* @__PURE__ */ o("div", { className: s("accordion", n), children: r({
    regionId: c,
    buttonId: a,
    expanded: e,
    expand: t
  }) });
}, y = ({
  className: n,
  children: r,
  initiallyExpanded: e = !1
}) => {
  const t = l(), c = l(), [a, i] = p((d) => !d, e);
  return /* @__PURE__ */ o("div", { className: s("accordion", n), children: r({
    regionId: c,
    buttonId: t,
    expanded: a,
    expand: i
  }) });
}, N = (n) => "onExpand" in n && typeof n.onExpand < "u", u = {
  header: "accordion__header",
  panel: "accordion__panel",
  action: "accordion__action"
}, j = ({
  onClick: n,
  className: r,
  container: e,
  expand: t,
  buttonId: c,
  regionId: a,
  expanded: i,
  children: d,
  toggleButton: m
}) => /* @__PURE__ */ f("div", { className: r, children: [
  /* @__PURE__ */ o(e, { className: s(u.header), children: /* @__PURE__ */ o(
    "button",
    {
      id: c,
      type: "button",
      "aria-expanded": i,
      "aria-controls": a,
      onClick: t,
      className: s({ "icon-clickable-area": !m }),
      children: m || /* @__PURE__ */ f(h, { children: [
        /* @__PURE__ */ o(
          v,
          {
            path: "chevron_right",
            className: "accordion__icon",
            style: {
              transform: i ? "rotate(90deg)" : void 0
            }
          }
        ),
        /* @__PURE__ */ o(A, { as: "span", children: d })
      ] })
    }
  ) }),
  /* @__PURE__ */ o(g, { onClick: n, className: u.action, children: d })
] }), g = ({
  onClick: n,
  children: r,
  className: e
}) => n ? /* @__PURE__ */ o("button", { type: "button", className: e, onClick: n, children: r }) : e ? /* @__PURE__ */ o("div", { className: e, children: r }) : r, O = ({ regionId: n, buttonId: r, expanded: e, children: t }) => {
  const [c, a] = b(e);
  return _(() => {
    !c && e && a(!0);
  }, [e, c]), /* @__PURE__ */ o(
    "div",
    {
      id: n,
      role: "region",
      "aria-labelledby": r,
      hidden: !e,
      className: u.panel,
      children: (e || c) && t
    }
  );
};
export {
  R as A,
  j as a,
  O as b
};
//# sourceMappingURL=AccordionPanel-BMJCOdex.js.map
